import DatePicker from "react-datepicker";
import React from 'react'
import { Button, Form,  Dimmer, Grid, Loader, Step } from 'semantic-ui-react'
import { inject, observer } from 'mobx-react'

import "react-datepicker/dist/react-datepicker.css";

@inject('SaleStore')
@observer
export default class SaleForm extends React.Component {

    constructor(props){
        super(props)
        this.store = this.props.SaleStore
    }

    render(){
        return (
            <Grid>
                <Dimmer page={true} active={this.store.isLoading} inverted><Loader /></Dimmer>
                <Form onSubmit={this.store.handleSaleForm}>

                    <Form.Group width="equal">
                        <Form.Dropdown
                            label="Cliente"
                            onChange={this.store.handleCustomerChange}
                            onSearchChange={this.store.handleCustomerSearchChange}
                            options={this.store.customers}
                            placeholder="Pesquise cliente por nome"
                            search
                            selection
                        />

                        <Form.Field>
                            <label htmlFor="customer_birth" >Data Nasc</label>
                            <DatePicker onChange={this.store.handleDatePicker} selected={this.store.sale.date} />
                        </Form.Field>

                        <Form.Dropdown
                            label="Produtos"
                            onChange={this.store.handleProductChange}
                            onSearchChange={this.store.handleProductSearchChange}
                            options={this.store.products}
                            placeholder="Pesquise cliente por nome"
                            search
                            selection
                        />
                    </Form.Group>
                    <Form.Group>
                        <Form.Input
                            type="number"
                            label="Quantidade" min={1}
                            value={parseInt(this.store.sale.products[0].quantity)}
                            onChange={this.store.onChageSaleQuantity}/>
                        <Form.Input type="number" step=".01" label="Total"  value={this.store.sale.amount}/>
                        <Step.Group>
                            <Step completed>
                                <Step.Content>
                                    <Step.Title>Status Do Pedido</Step.Title>
                                    <Step.Description>{this.store.sale_status}</Step.Description>
                                </Step.Content>
                            </Step>
                        </Step.Group>
                    </Form.Group>
                    <Button color="teal" fluid size="large" type="submit" >Salvar</Button>
                </Form>
            </Grid>
        )
    }
}